import {Modal} from '@/components/atoms'
import {useSelectionModalContent} from '@/containers/Promotions/components/SelectionModalContent/selectionModalContent-hook'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {BuyType} from '@/utils/constants/promotionConstants'
import {useMemo} from 'react'
import SelectionModalContentV2 from './SelectionModalContent/SelectionModalContentV2'

const PromotionSelectionModalV2 = ({show, type, onClose, onSubmit, conditionValues, isExclude = false}) => {
  const modalKey = useMemo(() => {
    return `${type}-${conditionValues?.itemType || ''}-${conditionValues?.values?.length || 0}-${conditionValues?.productCombination || false}`
  }, [type, conditionValues])

  const selectionModalHookValue = useSelectionModalContent(type, conditionValues)
  const {combination, selectedTags, isPrimaryButtonDisabled} = selectionModalHookValue

  const getModalTitle = () => {
    switch (type) {
      case BuyType.CATEGORY:
        return 'Category / Sub Category'
      case BuyType.BRAND:
        return 'Brands / Sub Brands'
      case BuyType.PRODUCT:
        return 'Products'
      case BuyType.PRODUCT_ID:
        return 'Product ID List'
      case BuyType.GTINS:
        return 'GTIN List'
      case BuyType.COMBO_ID:
        return 'Combo ID List'
      default:
        return ''
    }
  }

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(selectedTags, combination)
    }
  }

  const getModalDescription = () => {
    if (isExclude) {
      return 'What do you want to exclude from this deal?'
    }
    switch (type) {
      case BuyType.CATEGORY:
      case BuyType.BRAND:
      case BuyType.PRODUCT:
        return 'What do you want this deal to apply to?'
      case BuyType.PRODUCT_ID:
      case BuyType.GTINS:
      case BuyType.COMBO_ID:
      default:
        return ''
    }
  }

  return (
    <Modal
      key={modalKey}
      showModal={show}
      isDark
      title={getModalTitle()}
      text={getModalDescription()}
      primaryButtonText="Apply"
      tertiaryButtonText="Cancel"
      showTertiaryButton={true}
      classNameWrapper="min-h-80"
      content={
        <SelectionModalContentV2 type={type} selectionModalHookValue={selectionModalHookValue} isExclude={isExclude} />
      }
      type={[BuyType.CATEGORY, BuyType.BRAND, BuyType.PRODUCT].includes(type) ? MODAL_TYPE.SMALL : MODAL_TYPE.FLUID}
      onClickTertiaryButton={onClose}
      onClickPrimaryButton={handleSubmit}
      hideCloseButton={true}
      primaryButtonDisabled={isPrimaryButtonDisabled}
    />
  )
}

export default PromotionSelectionModalV2
